import Model from 'models/Model';
import lossCodeCategoryDeleteApi from './delete/Api.LossCodeCategory.Delete';
import lossCodeCategoryListApi from './list/Api.LossCodeCategory.List';
import lossCodeCategorySaveApi from './save/Api.LossCodeCategory.Save';

export default class LossCodeCategory
  extends Model<Model.ILossCodeCategory>({ icon: 'fas-list' })
  implements Model.Instance<Model.ILossCodeCategory>
{
  id: number;
  nameEn: string;
  nameFr: string;

  constructor(
    data: Partial<Model.ILossCodeCategory> | Utils.FormData<Model.ILossCodeCategory>,
    language?: Locale.Languages
  ) {
    super({}, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.nameEn || this.id.toString(),
      info: this.nameFr,
    };
  }
  static async list(body?: Api.Core.LossCodeCategory.List.IRequest) {
    const { payload, ...rest } = await lossCodeCategoryListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new LossCodeCategory(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await lossCodeCategorySaveApi(this);
  }
  async delete() {
    return await lossCodeCategoryDeleteApi(this.id);
  }
}
